import React from 'react';
import { ApprovalDetailField } from './ApprovalDetailField';
import type { ColorPalette } from '../constants/colors';
import type { WorkflowDetails } from '../types/workflow';
import { getHrAdminApprovalFields } from '../utils/hrAdminApprovalFields';

type Props = {
  details: WorkflowDetails;
  palette: ColorPalette;
};

export function HrAdminApprovalFields({ details, palette }: Props) {
  return (
    <>
      {getHrAdminApprovalFields(details).map(field => (
        <ApprovalDetailField
          key={field.label}
          label={field.label}
          value={field.value}
          palette={palette}
          expandable={field.expandable}
          link={field.link}
        />
      ))}
    </>
  );
}
